import React from "react"
import PropTypes from "prop-types"
import { parseISO, add } from "date-fns"
import { format } from "date-fns-tz"
import theme from "theme"

const TalkTime = ({ time, duration, className }) => (
  <div css={theme.hxs} className={className}>
    {format(parseISO(time), "L/d h:mm")}–
    {format(add(parseISO(time), { minutes: duration }), "h:mmaaa zzz")}
  </div>
)

export default TalkTime

TalkTime.propTypes = {
  time: PropTypes.string.isRequired,
  duration: PropTypes.number.isRequired,
  className: PropTypes.string,
}
